const RANKING_ITEMS = [
  { rank: 1, title: '我独自升级', type: '韩漫·完结', heat: '🔥 985万阅读', trend: 'up', change: '+2' },
  { rank: 2, title: '咒术回战', type: '日漫·连载', heat: '🔥 872万阅读', trend: 'up', change: '+1' },
  { rank: 3, title: '秘密教学', type: '韩漫·连载', heat: '🔥 756万阅读', trend: 'down', change: '-2' },
  { rank: 4, title: '鬼灭之刃', type: '日漫·完结', heat: '⭐ 698万阅读', trend: 'same', change: '-' },
  { rank: 5, title: '全知读者视角', type: '韩漫·连载', heat: '⭐ 623万阅读', trend: 'up', change: '+3' },
  { rank: 6, title: '排球少年！！', type: '日漫·完结', heat: '⭐ 587万阅读', trend: 'down', change: '-1' },
];

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-primary-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            漫画排行
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">下拉式漫画热度排行榜</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">根据阅读量和讨论热度实时更新的漫画榜单</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-100 overflow-hidden">
            {RANKING_ITEMS.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                  idx < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-background-50/50 transition-colors cursor-pointer`}
              >
                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                    rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="font-bold text-foreground-950 text-sm md:text-base truncate">{item.title}</div>
                  <div className="text-xs text-foreground-500">{item.type}</div>
                </div>

                <div className="text-right flex-shrink-0">
                  <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.heat}</div>
                  <div className="flex items-center justify-end gap-1 text-xs">
                    {item.trend === 'up' && (
                      <span className="text-accent-500 flex items-center gap-0.5">
                        <i className="ri-arrow-up-line text-xs"></i>
                        {item.change}
                      </span>
                    )}
                    {item.trend === 'down' && (
                      <span className="text-foreground-400 flex items-center gap-0.5">
                        <i className="ri-arrow-down-line text-xs"></i>
                        {item.change}
                      </span>
                    )}
                    {item.trend === 'same' && (
                      <span className="text-foreground-400">-</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}